import { Input } from '@/components/ui/input'
import { Checkbox } from '@/components/ui/checkbox'
import { useCalculatorStore } from '@/store/calculatorStore'

const ExtraPoints = () => {
  const { birthyear, studyStartYear } = useCalculatorStore(
    (state) => state.userDetails
  )
  const extraPoints = useCalculatorStore((state) => state.extraPoints)
  const setBirthYear = useCalculatorStore((state) => state.setBirthYear)
  const setExtraPoints = useCalculatorStore((state) => state.setExtraPoints)
  const setStudyStartYear = useCalculatorStore(
    (state) => state.setStudyStartYear
  )
  const studyStartYearIs2028OrLater = studyStartYear >= 2028

  return (
    <>
      <h2 className="text-xl lg:text-2xl font-bold mt-14 mb-3">
        Alders- og tillegspoeng
      </h2>
      <p className="text-sm mb-8">
        Du kan få inntil 8 alderspoeng og maks 2 tilleggspoeng.
      </p>
      <label htmlFor="birthYear" className="block text-base font-bold mb-2">
        Hvilket år er du født?{' '}
        <span className="text-xs font-medium text-gray-400">
          (Brukes til å beregne alderspoeng)
        </span>
      </label>
      <Input
        type="number"
        id="birthYear"
        placeholder="Skriv inn fødselsår"
        className="h-12 max-w-48 border-warm-gray-600 shadow-[0_2px_4px_0_rgba(0,0,0,0.1)]"
        value={birthyear}
        onChange={(e) => setBirthYear(parseInt(e.target.value))}
        data-testid="birth-year-input"
      />
      <label
        htmlFor="studyStartYear"
        className="block text-base font-bold mb-2 mt-8"
      >
        Når ønsker du å starte å studere?{' '}
        <span className="text-xs font-medium text-gray-400">
          (Alderspoeng beregnes ut fra hvor gammel du vil være da)
        </span>
      </label>
      <div className="flex flex-col md:flex-row gap-4 md:items-center">
        <Input
          type="number"
          id="studyStartYear"
          placeholder="Skriv inn studiestartår"
          className="h-12 max-w-48 border-warm-gray-600 shadow-[0_2px_4px_0_rgba(0,0,0,0.1)]"
          value={studyStartYear}
          onChange={(e) => setStudyStartYear(parseInt(e.target.value))}
          data-testid="study-start-year-input"
        />
        {studyStartYearIs2028OrLater && (
          <div className="flex items-center h-auto md:h-12 max-w-fit px-2 py-2 bg-yellow-100 border border-yellow-300 rounded-md text-xs text-gray-500">
            <span>
              Fra opptaket høsten 2028 endres reglene for ekstrapoeng. Les mer{' '}
              <a
                href="https://www.samordnaopptak.no/universitet-og-hogskole/aktuelt/nye-regler-for-opptak-til-hoyere-utdanning.html"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline hover:text-blue-800"
              >
                her
              </a>
              .
            </span>
          </div>
        )}
      </div>
      <fieldset className="mt-8 grid grid-cols-1 gap-4">
        <legend className="block text-base font-bold mb-2">
          Har du gjort noe av dette etter videregående?
        </legend>
        <div className="flex items-center gap-3 text-sm">
          <Checkbox
            id="militaryService"
            className="border-warm-gray-700 data-[state=checked]:bg-purple-600 data-[state=checked]:border-purple-600"
            checked={extraPoints['Militær/siviltjeneste']}
            onCheckedChange={(checked) => {
              setExtraPoints({
                ...extraPoints,
                'Militær/siviltjeneste': checked === true,
              })
            }}
            data-testid="military-service-checkbox"
          />
          <label htmlFor="militaryService">
            Førstegangstjeneste/siviltjeneste
          </label>
          {studyStartYearIs2028OrLater && (
            <span className="text-gray-500">(1 poeng fra 2028)</span>
          )}
        </div>
        <div
          className={`flex items-center gap-3 text-sm ${
            studyStartYearIs2028OrLater ? 'text-gray-400' : ''
          }`}
        >
          <Checkbox
            id="folkHighSchool"
            className="border-warm-gray-700 data-[state=checked]:bg-purple-600 data-[state=checked]:border-purple-600"
            checked={extraPoints.Folkehøgskole}
            disabled={studyStartYearIs2028OrLater}
            onCheckedChange={(checked) => {
              setExtraPoints({
                ...extraPoints,
                Folkehøgskole: checked === true,
              })
            }}
            data-testid="folk-high-school-checkbox"
          />
          <label htmlFor="folkHighSchool">Folkehøgskole</label>
        </div>
        <div
          className={`flex items-center gap-3 text-sm ${
            studyStartYearIs2028OrLater ? 'text-gray-400' : ''
          }`}
        >
          <Checkbox
            id="30StudyPoints"
            className="border-warm-gray-700 data-[state=checked]:bg-purple-600 data-[state=checked]:border-purple-600"
            checked={extraPoints['30 studiepoeng']}
            disabled={studyStartYearIs2028OrLater}
            onCheckedChange={(checked) => {
              setExtraPoints({
                ...extraPoints,
                '30 studiepoeng': checked === true,
              })
            }}
            data-testid="30-study-points-checkbox"
          />
          <label htmlFor="30StudyPoints">
            30 studiepoeng fra fagskole eller høyere utdanning
          </label>
        </div>
        <div
          className={`flex items-center gap-3 text-sm ${
            studyStartYearIs2028OrLater ? 'text-gray-400' : ''
          }`}
        >
          <Checkbox
            id="60StudyPoints"
            className="border-warm-gray-700 data-[state=checked]:bg-purple-600 data-[state=checked]:border-purple-600"
            checked={extraPoints['60 studiepoeng']}
            disabled={studyStartYearIs2028OrLater}
            onCheckedChange={(checked) => {
              setExtraPoints({
                ...extraPoints,
                '60 studiepoeng': checked === true,
              })
            }}
            data-testid="60-study-points-checkbox"
          />
          <label htmlFor="60StudyPoints">
            60 studiepoeng fra fagskole eller høyere utdanning
          </label>
        </div>
      </fieldset>
    </>
  )
}

export default ExtraPoints
